<mat-card appearance="outlined" color="black">
    <mat-card-content>
        <a (click)="router.navigate(['edit-organization', organization.id])">
            <div class="organization-card-contents">
                <div class="organization-name">{{ organization.name }}</div>
                <div class="organization-machines">ilość maszyn: {{ getMachinesCount(organization) }}</div>
            </div>
        </a>
    </mat-card-content>
</mat-card>